export const components = {
  StartConfig: () => import('./steps/StartConfig.vue'),
  Dependent: () => import('./steps/Dependent.vue'),
  Customer: () => import('./steps/Customer.vue'),
  Payment: () => import('./steps/Payment.vue'),
  Resume: () => import('./steps/Resume.vue'),
  ResumeOld: () => import('./steps/ResumeOld.vue'),
  ResumeDependent: () => import('./steps/ResumeDependent.vue'),
  PosVenda: () => import('./steps/PosVenda.vue')
};

export const defaultTerm = ['StartConfig', 'Customer', 'Payment', 'Resume'];
export const termoFamiliaTitular = ['StartConfig', 'Customer', 'Payment', 'Resume'];
export const termoFamiliaDependente = ['StartConfig', 'Dependent', 'ResumeDependent'];
export const posVenda = ['StartConfig', 'Customer', 'Resume'];
export const posVendaTransfTitular = ['StartConfig', 'Customer', 'Payment', 'Resume'];
export const posVendaTransfTitularOld = ['StartConfig', 'Customer', 'Payment', 'ResumeOld'];
export const defaultTermOld = ['StartConfig', 'Customer', 'Payment', 'ResumeOld'];
export const serviceTypeSCM = ['StartConfig', 'Customer', 'ResumeOld'];

export const getSteps = function (term) {
  if (term.tipoServico === 'scm') {
    return serviceTypeSCM;
  }
  if (term.tipoServico === 'smp' && term.plan === 'family') {
    if (term.justDependent) {
      return termoFamiliaDependente;
    }
    return termoFamiliaTitular;
  }
  if (term.tipoVenda === 'posVenda' && term.posVenda.isTransferencia) {
    if (term.tipoServico !== 'smp' || term.plan === 'wttx') {
      return posVendaTransfTitularOld;
    }
    return posVendaTransfTitular;
  }
  if (term.tipoVenda === 'posVenda' && term.posVenda.isMudancaPlano) {
    if (term.tipoServico !== 'smp' || term.plan === 'wttx') {
      return posVendaTransfTitularOld;
    }
    return posVendaTransfTitular;
  }
  if (term.tipoVenda === 'posVenda' && term.posVenda.isMudancaNumero) {
    if (term.tipoServico !== 'smp' || term.plan === 'wttx') {
      return defaultTermOld;
    }
    return defaultTerm;
  }
  if (term.tipoVenda === 'posVenda' && term.posVenda.isBaseLoyalty) {
    if (term.tipoServico !== 'smp' || term.plan === 'wttx') {
      return defaultTermOld;
    }
    return defaultTerm;
  }
  if (term.tipoVenda === 'posVenda' && term.posVenda.isMigrationTransfer) {
    if (term.tipoServico !== 'smp' || term.plan === 'wttx') {
      return defaultTermOld;
    }
    return defaultTerm;
  }
  if (term.tipoVenda === 'posVenda') {
    return posVenda;
  }
  if (term.tipoServico !== 'smp' || term.plan === 'wttx') {
    return defaultTermOld;
  }
  return defaultTerm;
};

export const isModal = function (currentStep, term) {
  return currentStep === 'Customer' && term.plan === 'family';
};

export const isModalResume = function (currentStep, term) {
  if (term.tipoServico === 'scm' && currentStep === 'Customer') {
    return true;
  }
  
  if (
    (term.tipoVenda === 'posVenda' &&
      currentStep === 'Customer' &&
      !term.posVenda.isTransferencia &&
      !term.posVenda.isMigrationTransfer &&
      !term.posVenda.isMudancaPlano &&
      !term.posVenda.isBaseLoyalty) ||
    (term.tipoVenda === 'posVenda' &&
      currentStep === 'Payment' &&
      (term.posVenda.isTransferencia || 
       term.posVenda.isMigrationTransfer || 
       term.posVenda.isMudancaPlano || 
       term.posVenda.isBaseLoyalty)) &&
    currentStep !== 'StartConfig'
  ) {
    return true;
  }
  
  return currentStep === 'Payment' || (term.justDependent && currentStep === 'Dependent');
}
